module.exports = __webpack_public_path__ + "img/speedometer-04.9d0e0caa.svg";